import { render, staticRenderFns } from "./ShoppingCartIcon.vue?vue&type=template&id=2f84fbc8&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports